import { Component, Input } from '@angular/core';

import { Gift } from '../../../../../../../../models/gift';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GiftService } from '../../../../../../../../services/gift/gift.service';


@Component({
  selector: 'app-expire-gift-immediately-modal',
  templateUrl: './expire-gift-immediately-modal.component.html',
  styleUrls: ['./expire-gift-immediately-modal.component.css']
})
export class ExpireGiftImmediatelyModalComponent {
  @Input() gift: Gift;
  @Input() successCallback: () => undefined;

  public willRefund = false;

  public loading = false;

  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    private giftService: GiftService,
  ) {}

  public onSubmit(){
    this.errorMessage = '';

    this.giftService
      .expireGiftImmediately(
        this.gift.id,
        this.willRefund
      )
      .then(() => {
        this.successCallback();
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to expire this gift.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
